export const PRODUCT_INFO_MISSING = 'productInfoMissing';
export const DEFAULT = 'default';